// Centrale configuratie voor AM Intelligence.
// Wijzig PARTNER_LIVE naar true zodra de partner live is:
// dan wijst "Vraag meer informatie" naar PARTNER_URL en toont het
// samenwerkingsblok PARTNER_NAME. "Plan een kennismaking" blijft
// altijd naar CONTACT_URL gaan.

export const PARTNER_NAME = 'een gespecialiseerde partner';
export const PARTNER_URL = '';
export const PARTNER_LIVE = false;

export const CONTACT_URL =
  'https://calendly.com/bert-lambrecht-am/dm?hide_gdpr_banner=1&primary_color=8B1A1A&text_color=111111';

export const SIGNAL_NAME = 'AM Sales Signal';

export const STATS = {
  bedrijven: '2,0M actieve bedrijven',
  datapunten: '250M datapunten',
  nbb: 'NBB 2007 tot 2025',
  markt: '15 jaar Belgische markt',
} as const;

export const STATS_LINE = `${STATS.bedrijven} · +${STATS.datapunten} · ${STATS.nbb} · ${STATS.markt}`;
